export default __webpack_public_path__ + "static-front/media/CloseIcon.c399bb41.svg";